export default [
  ':active',
  ':any',
  ':checked',
  ':default',
  ':disabled',
  ':empty',
  ':enabled',
  ':first',
  ':first-child',
  ':first-of-type',
  ':fullscreen',
  ':focus',
  ':hover',
  ':indeterminate',
  ':in-range',
  ':invalid',
  ':last-child',
  ':last-of-type',
  ':left',
  ':link',
  ':only-child',
  ':only-of-type',
  ':optional',
  ':out-of-range',
  ':read-only',
  ':read-write',
  ':required',
  ':right',
  ':root',
  ':scope',
  ':target',
  ':valid',
  ':visited',

  // With value
  ':dir',
  ':lang',
  ':not',
  ':nth-child',
  ':nth-last-child',
  ':nth-last-of-type',
  ':nth-of-type',

  // Elements
  '::after',
  '::before',
  '::first-letter',
  '::first-line',
  '::selection',
  '::backdrop',
  '::placeholder',
  '::marker',
  '::spelling-error',
  '::grammar-error'
]
